module.exports = __webpack_public_path__ + "img/text4.c16f8471.png";